if (
  process.env.NODE_ENV === 'development' &&
  process.env.HOT_RELOADING !== 'true'
) {
  require('preact/debug')
}
import React from 'react'
import ReactDOM from 'react-dom'
import { HeadProvider } from 'react-head'
import '../index.scss'
import App from './AppComponent'
import { Provider } from 'react-redux'
import { getStoreConfiguration } from './store/store'
import { configureStore } from 'redux-starter-kit'
import { Router } from 'react-router-dom'
import routes from './routes'
import { loadableReady } from '@loadable/component'
import history from './historyObject'
import 'what-input'
import { getAbTestsFromCookie } from 'lifesum-ssr/server/shared'

const store = configureStore(getStoreConfiguration(window.PRELOADED_STATE))
const rootElement = document.getElementById('mount')
const abTests = getAbTestsFromCookie(document.cookie || '')

Promise.all([
  import(/* webpackChunkName: "Throttle" */ 'throttle-debounce'),
  import(/* webpackChunkName: "LocalStorage" */ './store/localStorage'),
]).then(([{ throttle }, storage]) =>
  store.subscribe(
    throttle(1000, () => {
      storage.saveState(store.getState())
    })
  )
)

async function loadPolyfills() {
  let polyfills = []
  if (typeof window.IntersectionObserver === 'undefined') {
    polyfills.push(import('intersection-observer'))
  }

  if (
    !('fetch' in window) ||
    !('startsWith' in String.prototype) ||
    !('endsWith' in String.prototype) ||
    !('includes' in Array.prototype) ||
    !('flatMap' in Array.prototype) ||
    !('assign' in Object) ||
    !('keys' in Object) ||
    !('values' in Object)
  ) {
    polyfills.push(import('whatwg-fetch'))
    polyfills.push(import('./polyfills'))
  }

  await Promise.all(polyfills)
}

loadPolyfills().then(() => {
  if (rootElement.hasChildNodes()) {
    loadableReady(() =>
      ReactDOM.hydrate(
        <Provider store={store}>
          <HeadProvider>
            <Router history={history}>
              <App
                routes={routes}
                initialData={window.DATA}
                initialPathname={history.location.pathname}
                defaultMessages={window.DEFAULT_MESSAGES}
                abTests={abTests}
                cloudfrontViewerCountry={window.CLOUDFRONT_VIEWER_COUNTRY}
              />
            </Router>
          </HeadProvider>
        </Provider>,
        rootElement
      )
    )
  } else {
    ReactDOM.render(
      <Provider store={store}>
        <HeadProvider>
          <Router history={history}>
            <App
              routes={routes}
              initialData={window.DATA}
              initialPathname={history.location.pathname}
              abTests={abTests}
              cloudfrontViewerCountry={window.CLOUDFRONT_VIEWER_COUNTRY}
            />
          </Router>
        </HeadProvider>
      </Provider>,
      rootElement
    )
  }
})
